import React, { useState } from "react";
import PrivacyNoticeModal from "./PrivacyNoticeModal";
import { DEFAULT_PRIVACY_LANGUAGE, PRIVACY_UI_TEXT } from "../../constants/privacyNotice";

/**
 * "I have read and accept the Privacy Notice" checkbox.
 * The underlined link opens the notice in a modal (English / Bahasa Melayu).
 * "I Agree" in the modal ticks the checkbox; closing the modal changes nothing.
 *
 * Controlled: pass `checked` and `onChange(boolean)`.
 */
const PrivacyConsent = ({ checked, onChange, id = "privacy-consent", className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useState(DEFAULT_PRIVACY_LANGUAGE);
  const text = PRIVACY_UI_TEXT[language];
  const hintId = `${id}-hint`;

  const handleAgree = () => {
    onChange(true);
    setIsOpen(false);
  };

  return (
    <div className={className}>
      <div
        className={`flex items-start gap-3 rounded-[8px]  px-3 py-3 transition-colors ${
          checked ? " bg-primary/5" : " bg-white"
        }`}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-describedby={checked ? undefined : hintId}
          className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border-[#11111126] accent-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        />
        <label htmlFor={id} lang={language} className="cursor-pointer text-[13px] leading-5 text-[#111111B8]">
          {text.consentPrefix}{" "}
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="font-medium text-primary underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
          >
            {text.linkText}
          </button>
          <span className="text-red-500" aria-hidden="true"> *</span>
        </label>
      </div>

      {/* {!checked && (
        <p id={hintId} lang={language} className="mt-1.5 px-1 text-[11px] text-[#1111117A]">
          {text.consentHint}
        </p>
      )} */}

      <PrivacyNoticeModal
        isOpen={isOpen}
        language={language}
        onLanguageChange={setLanguage}
        onAgree={handleAgree}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default PrivacyConsent;
